module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9cc3b64cc7747cc8e7bf59dc8a1614e0.gif";